import { sendAnalyticsEvents } from 'google-analytics';

export const createEvent = (eventName: any, action: any) => {
  sendAnalyticsEvents({
    event_name: 'cart_v2_event',
    event_params: {
      cart_update_method: eventName,
      action: action,
    },
  });
};